module.exports = __webpack_public_path__ + "static/media/next-page-pagination.018034d4.svg";